export default __webpack_public_path__ + "static/media/about-6.c9b7160c.jpg";